









































import {Component, Vue} from "vue-property-decorator";
import CoverSection from "@/sections/CoverSection.vue";
import ContentSection from "@/sections/ContentSection.vue";
import axios from "axios";

@Component({
    components: {CoverSection, ContentSection}
})
export default class About extends Vue {

    public name: string = "";
    public email: string = "";
    public tel: string = "";
    public msg: string = "";

    public responseMsg: string = "";
    public responseError: boolean = false;

    public submit(e: any): void {
        const formData = new FormData();
        formData.set("name", this.name);
        formData.set("from", this.email);
        formData.set('telephone', this.tel);
        formData.set("message", this.msg);

        axios.post("/php/mail.php", formData)
            .then(() => {
                this.responseMsg = "Besten Dank für Ihre Nachricht. Wir werden Ihr Anliegen in Kürze bearbeiten.";
                this.responseError = false;

                this.name = "";
                this.email = "";
                this.tel = "";
                this.msg = "";
            })
            .catch(() => {
                this.responseMsg = "Leider konnte die Nachricht nicht versendet werden. Informieren Sie uns über info@lockio.ch.";
                this.responseError = true;
            });

        e.preventDefault();
    }
}
